"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _Workspace = require("../records/Workspace");

var _PayloadActions = require("../actions/PayloadActions");

var _WorkspaceActions = require("../actions/WorkspaceActions");

var _handleActions;

var initialState = (0, _immutable.Map)();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _PayloadActions.FetchPayloadActionTypes.SUCCESS, function (state, action) {
  return state.withMutations(function (map) {
    action.payload.data.workspaces.reduce(function (acc, ws) {
      return acc.set(ws.id, (0, _Workspace.fromJSON)(ws));
    }, map);
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _fluxActions.combineActions)(_WorkspaceActions.CreateWorkspaceActionTypes.SUCCESS, _WorkspaceActions.EditWorkspaceActionTypes.SUCCESS, _WorkspaceActions.DeleteWorkspaceMembersActionTypes.SUCCESS, _WorkspaceActions.AddWorkspaceMembersActionTypes.SUCCESS), function (state, action) {
  var workspace = action.payload.data.workspace;
  return state.set(workspace.id, (0, _Workspace.fromJSON)(workspace));
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.DeleteWorkspaceActionTypes.SUCCESS, function (state, action) {
  var workspace = action.payload.data;
  return state.delete(workspace.id);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;